import type { ResultOf } from '@graphql-typed-document-node/core';

import { ActorTypeEnum, getFragmentData, graphql } from '@e-socna/data-layer';
import type { Id, FragmentType } from '@e-socna/data-layer';

import { OrganizationActorCard } from './Organization';
import { PersonActorCard } from './Person';

export const ActorCardCmp_Actor_Fragment = graphql(`
  fragment ActorCardCmp_Actor_Fragment on Actor {
    _id
    __typename
    typeId
    kind
    ... on ActorOrganization {
      ...ActorCardCmp_ActorOrganization_Fragment
    }
    ... on ActorPerson {
      ...ActorCardCmp_ActorPerson_Fragment
    }
  }
`);

export type ActorCardCmp_Actor = ResultOf<typeof ActorCardCmp_Actor_Fragment>;

interface Props {
  readonly actionsEnabled?: boolean;
  readonly actor: FragmentType<typeof ActorCardCmp_Actor_Fragment>;
  readonly consultThirdPartyInNewTab: boolean;
  readonly onStartRemove?: (id: Id) => void;
  readonly onStartUpdate?: (id: Id) => void;
}

export const ActorCard = ({
  actionsEnabled = false,
  actor: pActor,
  consultThirdPartyInNewTab,
  onStartRemove: handleStartRemove,
  onStartUpdate: handleStartUpdate,
}: Readonly<Props>) => {
  const actor = getFragmentData(ActorCardCmp_Actor_Fragment, pActor);

  switch (actor.__typename) {
    case 'ActorOrganization':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ActorTypeEnum.ActorOrganization:
      return (
        <OrganizationActorCard
          actionsEnabled={actionsEnabled}
          actor={actor}
          consultThirdPartyInNewTab={consultThirdPartyInNewTab}
          onStartRemove={handleStartRemove}
          onStartUpdate={handleStartUpdate}
        />
      );
    case 'ActorPerson':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ActorTypeEnum.ActorPerson:
      return (
        <PersonActorCard
          actionsEnabled={actionsEnabled}
          actor={actor}
          consultThirdPartyInNewTab={consultThirdPartyInNewTab}
          onStartRemove={handleStartRemove}
          onStartUpdate={handleStartUpdate}
        />
      );
    default:
      throw new Error('Unknown actor type');
  }
};
